import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { ResultGrid } from "./FacetResultGrid/FacetResultGrid";
import { isEqual } from "lodash";
import eventBus from "../../events/eventBus";

const message = {
  id: "1B28EFFFF1C300020713000001DC0001",
  title: "Dossier - Test1",
  subTitle: "03/12/2020 12:00:00",
  read: false,
  status: "success",
  icon: "success",
  statusCode: 0,
  action: "openUrl",
  url:
    'frm://ecompta_interrogationcomptetiers.dfm//?params="ArgLettrageTotal=mptBoolean(false)&ArgSelectTypeCollectif=mptBoolean(true)"&options="seoReadOnly,seoRootForm,seoRefreshAfterLoad"',
  activity: { status: "En cours", enable: true, duestate: "adsOverdue" },
  actions: [
    {
      title: "Succès",
      kind: "success",
      name: "execute",
      param: {
        class: "TdbfActivity",
        oid: "1B28EFFFF1C300020713000001DC0001",
        method: "validate",
      },
    },
    {
      title: "Echec",
      kind: "error",
      name: "execute",
      param: {
        class: "TdbfActivity",
        oid: "1B28EFFFF1C300020713000001DC0001",
        method: "unvalidate",
      },
    },
    {
      title: "Annuler",
      kind: "warning",
      name: "execute",
      param: {
        class: "TdbfActivity",
        oid: "1B28EFFFF1C300020713000001DC0001",
        method: "cancel",
      },
    },
    {
      title: "Ouvrir",
      kind: "default",
      name: "openUrl",
      param: {
        url:
          'frm://ecompta_interrogationcomptetiers.dfm//?params="ArgLettrageTotal=mptBoolean(false)&ArgSelectTypeCollectif=mptBoolean(true)"&options="seoReadOnly,seoRootForm,seoRefreshAfterLoad"',
      },
    },
  ],
};

const messages = [
  message,
  { ...message, id: "2", read: false, actions: undefined },
  {
    id: "000000000000000000B7000005310074",
    icon: "email",
    title: "Edition des sociétés",
    subTitle: "22/12/2021 15:28:43",
    status: "success",
    statusCode: 0,
    content:
      "Tâche : Edition des sociétés,Type : print,Dossier : Démo - Sage FRP 1000 Suite Financière - MultiSociétés,Utilisateur : sage,Société(s) : S1,Début : 22/12/2021 14:28:37,...",
    rawContent:
      'Tâche : Edition des sociétés\r\nType : print\r\nDossier : Démo - Sage FRP 1000 Suite Financière - MultiSociétés\r\nUtilisateur : sage\r\nSociété(s) : S1\r\nDébut : 22/12/2021 14:28:37\r\nFin : 22/12/2021 14:28:43\r\nDurée : 6 s\r\nFichiers : 1\r\nModRtreso_societes.pdf\r\nStatut : 0 \r\n\r\nMessages :\r\nRequête OK\r\n\r\nDebug :\r\nMessageClassName="TStaticRegClass"\r\nMessageDatetime="22/12/2021 15:28:36"\r\nMessageUser="sage"\r\nMessageOID="1B28EFFFF1C30002071A0000054D0001"\r\nMessageID="85255"\r\nTopic="000000000000000000500000000401C3.QPrint"\r\nState="0"\r\nMessageRefOID=""\r\nOriginalUniqueID=""\r\noiddbmQueue="0000000000000000009A000000070010"\r\nQueueName="QPrint"\r\nUniqueID="85255"\r\nmessage.share.mode="Loop"\r\nmessage.share.societies="1B28EFFFF1C30002000300000003000B"\r\nmessage.action="print"\r\nmessage.id="DC14DD0BE5C34F6F95ACF218E856"\r\nmessage.notify.event.id="print.DC14DD0BE5C34F6F95ACF218E856"\r\nmessage.notify.event="1"\r\nmessage.accessToken="1000030038E5BCA214C1E540FB00ABAB78C11195679C6F2E440CA3F1E3BC85D27C0F3AE03262B931087E086366D9E36E6AADF23A53A7C03AAADF9CE17E824CC5F2C9F859211FA1927EFB65CC9D699239499570C3237C1F475EAB5AF83CAC5C7507FAED4D3D8EDD56E24B2722E4DAD7FDD55B656F566EB71CFD22138CAE3C39E2AE4EEBC04A4072FA8C95059137FAD33D760490A77EDFE9073DF812628A4F6855CC0DE06BCFED7282A0C658B32C10E2846F8AA42F708C0EEAFD7AE4C72D38208A99DD2A37C1014DC6C20F89DFDA9CD45ABE18F92D3FE1BDCFED2BC0879E7D2D145F2FE48FC20F12C4BBA6A1EC3EC69C2E1139D951ECFFC49FAFD4A331E2DF542B99576B0D1512C89B4655627585B4D5E7"\r\nmessage.title="Edition des sociétés"\r\nprint.parameters="!PrintMode=FILE\r\n!FileName=ModRtreso_societes.dfm\r\n!ConfigForm=lertreso_societes.dfm\r\n!Caption=Edition des sociétés\r\n!TypeAction=3\r\n!ShareSocietyPerimeter=1B28EFFFF1C30002000300000003000B\r\n!ShareSocieties=1B28EFFFF1C30002000300000003000B,1B28EFFFF1C300020003000000030086,1B28EFFFF1C3000200030000053E026E,1B28EFFFF1C3000200030000053E1A7A\r\n!SharePerimeters=1B28EFFFF1C300020002000000420002,1B28EFFFF1C30002000300000003000B,1B28EFFFF1C3000200030000007E0001,1B28EFFFF1C3000200030000007E0003,1B28EFFFF1C300020003000000030086,1B28EFFFF1C3000200030000053E026E,1B28EFFFF1C3000200030000053E1A7A\r\n!ShareEntity=1B28EFFFF1C300020001000002CD003D\r\n!ShareRestitution=TRUE\r\n!ShareAllPerimeters=FALSE\r\nCaption=\r\nCURRENCYSTYLE=2\r\nCURRENCYVIEW=\r\nDATEEVALUATION=2021-12-22\r\nDATEEVALUATIONFIXE=false\r\nDATERATEMAX=2021-12-22\r\nDETAILCOMPTESBANCAIRES=true\r\nDETAILSOCIETES=true\r\nFILEENCODING=\r\nFILEEXPORT=\r\nLABELSCOUNT=0\r\nMBDESTINATAIRE=\r\nObjectClassLabel=Q_rtreso_societes_1408171439_P_6D100AE1\r\nObjectClassName=Q_RTRESO_SOCIETES_1408171439_P_6D100AE1\r\noid=\r\noidShare=\r\nRATESTYLE=0\r\nSHAREAGGREGATE=true\r\nShareInfo=\r\nShareInstanceInfo=\r\nShareInstanceLevel=\r\nShareInstanceRequestedLevel=\r\nShareLevel=-1\r\nSOCIETES=\r\nUserCaption=\r\n!StyleExport=PDF"\r\nmessage.notify.bam="sage"\r\nmessage.notify.tweet="sage"',
    read: false,
    actions: [
      {
        id: "000000000000000000B0000005310075",
        title: "ModRtreso_societes.pdf",
        name: "download",
        download: { name: "ModRtreso_societes.pdf", url: "" },
      },
    ],
  },
  { ...message, id: "4", read: false },
  { ...message, id: "5", read: true },
  { ...message, id: "6", read: true },
  { ...message, id: "7", read: true },
];

const FacetCardList = ({ facet, control, ...props }) => {

  const { loadMethod, updateEvent } = facet;
  // for production should be replaced by useState([])
  const [items, setItems] = useState([]);
  const [updateEventContent, setUpdateEventContent] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (updateEvent) {
      const memoizedCallback = (newUpdateEventContent) => {
        const isNewContentAvailable = !isEqual(
          newUpdateEventContent,
          updateEventContent
        );
        if (isNewContentAvailable) {
          setUpdateEventContent(newUpdateEventContent);
          control.callMethod(loadMethod, {}, (data) => {
            if (Array.isArray(data?.data)) {
              setItems(data?.data);
            }
          });
        }
      };

      eventBus.on(updateEvent, memoizedCallback);

      return () => {
        eventBus.remove(updateEvent, memoizedCallback);
      };
    }
  }, [updateEvent, control, loadMethod, updateEventContent]);

  useEffect(() => {
    setLoading(true);
    control.callMethod(loadMethod, {}, (data) => {
      if (Array.isArray(data?.data)) {
        setItems(data?.data);
      }
      setLoading(false);
    });
  }, [control, loadMethod]);

  return (
    <ResultGrid
      usingLoading
      loading={loading}
      kind="card"
      facet={facet}
      control={control}
      items={items}
      keyboardSupport={false}
      {...props}
    />
  );
};

export default FacetCardList;
